export default __webpack_public_path__ + "static/media/phone_black_18dp.a688a651.svg";